import { useEffect, useState } from "react";
import { PackageOpen, PackageCheck } from "lucide-react";
import api from "@/lib/api";
import { num, fmtDate } from "@/lib/format";
import RijekButton from "@/components/RijekButton";

function Column({ title, icon: Icon, tone, data, testId, onDone }) {
  const tones = { blue: "text-blue-700 bg-blue-50 border-blue-200", emerald: "text-emerald-700 bg-emerald-50 border-emerald-200" };
  return (
    <div className="rounded-md border border-slate-200 bg-white overflow-hidden" data-testid={testId}>
      <div className={`flex items-center justify-between px-4 py-2.5 border-b ${tones[tone]}`}>
        <div className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-wider"><Icon className="w-4 h-4" />{title}</div>
        <div className="mono text-sm font-extrabold" data-testid={`${testId}-total`}>{num(data.total_qty)} PCS · {data.worker_count} worker</div>
      </div>
      {data.workers.length === 0 ? (
        <div className="px-4 py-6 text-sm text-slate-400 text-center" data-testid={`${testId}-empty`}>Belum ada aktivitas · 0 PCS</div>
      ) : (
        <div className="divide-y divide-slate-100">
          {data.workers.map((w) => (
            <div key={w.worker_id} className="px-4 py-3 flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4" data-testid={`${testId}-worker-${w.worker_id}`}>
              <div className="sm:w-44 shrink-0">
                <div className="mono text-xs font-bold text-slate-500">{w.worker_id}</div>
                <div className="text-sm font-semibold text-slate-900">{w.worker_name}</div>
              </div>
              <div className="flex-1 space-y-1">
                {w.items.map((it) => (
                  <div key={it.product_id || it.product_name} className="flex items-center justify-between text-sm gap-2">
                    <span className="text-slate-700">{it.product_name}{it.count > 1 && <span className="text-[10px] text-slate-400 ml-1">({it.count} trx)</span>}{tone === "emerald" && it.product_id && <RijekButton wid={w.worker_id} productId={it.product_id} productName={it.product_name} setorEfektif={null} onDone={onDone} />}</span>
                    <span className="mono font-semibold text-slate-800">{num(it.qty)} PCS{tone === "emerald" && it.reject > 0 && <span className="text-rose-600 text-xs ml-1">(reject {num(it.reject)})</span>}</span>
                  </div>
                ))}
              </div>
              <div className="sm:w-28 text-right shrink-0">
                <div className="text-[10px] uppercase tracking-wider text-slate-400">Total</div>
                <div className="mono text-base font-extrabold text-slate-900" data-testid={`${testId}-worker-${w.worker_id}-total`}>{num(w.total_qty)} PCS</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function WorkerActivityToday() {
  const [d, setD] = useState(null);
  const load = () => api.get("/dashboard/worker-activity-today").then((r) => setD(r.data));
  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);
  if (!d) return null;
  return (
    <div className="bg-white rounded-lg border border-slate-200 shadow-sm p-4 sm:p-5" data-testid="panel-worker-activity-today">
      <div className="flex items-center justify-between mb-3">
        <div className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">Aktivitas Worker Hari Ini</div>
        <div className="text-xs text-slate-400" data-testid="worker-activity-date">{fmtDate(d.date)} · WITA · hanya transaksi CONFIRMED</div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <Column title="Ambil Hari Ini" icon={PackageOpen} tone="blue" data={d.ambil} testId="activity-ambil" />
        <Column title="Setor Hari Ini" icon={PackageCheck} tone="emerald" data={d.setor} testId="activity-setor" onDone={load} />
      </div>
    </div>
  );
}
